import {
  acceptAllSuggestions,
  acceptSuggestionsInRange,
  applySuggestion,
  rejectAllSuggestions,
  rejectSuggestionsInRange,
  setSuggestionMode,
  setSuggestionModeCommand,
  suggestionModePlugin,
  suggestionPluginKey,
  type TextSuggestion,
  toggleSuggestionMode,
} from 'prosemirror-suggestion-mode';
import { type EditorState, type Plugin } from 'prosemirror-state';
import { type EditorView } from 'prosemirror-view';

export type TrackChangesOptions = {
  userId: string;
  enabled?: boolean;
};

export function trackChangesPlugin(opts: TrackChangesOptions): Plugin {
  return suggestionModePlugin({
    inSuggestionMode: opts.enabled ?? true,
    username: opts.userId,
  });
}

export function isSuggestionModeOn(state: EditorState): boolean {
  return suggestionPluginKey.getState(state)?.inSuggestionMode ?? false;
}

export function setTrackingEnabled(view: EditorView, enabled: boolean) {
  setSuggestionMode(view, enabled);
}

export {
  acceptAllSuggestions,
  acceptSuggestionsInRange,
  applySuggestion,
  rejectAllSuggestions,
  rejectSuggestionsInRange,
  setSuggestionModeCommand,
  suggestionPluginKey,
  toggleSuggestionMode,
};
export type { TextSuggestion };
